import { Row } from "antd";
import Modal from "../modal/Modal";
import TextComponent from "../textComponent/TextComponent";
import SubmitButton from "../submitButton/SubmitButton";
import styles from "./PhoneNumberModal.module.css";
import { useState } from "react";

const PhoneNumberModal = ({
  isPhoneModalOpen,
  setIsPhoneModalOpen,
  phoneNumber,
}) => {
  const [isCopied, setIsCopied] = useState(false);

  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(phoneNumber)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Modal
      isModalOpen={isPhoneModalOpen}
      setIsModalOpen={setIsPhoneModalOpen}
      closable={true}
      className={styles.modal}
    >
      <Row className={styles.modalCont}>
        <TextComponent text={"Phone Number"} textClass={styles.PhoneTitle} />
        <TextComponent text={phoneNumber} textClass={styles.PhoneNum} />
        <SubmitButton
          title={isCopied ? "Copied" : "Copy"}
          onClick={handleCopyClick}
        />
      </Row>
    </Modal>
  );
};

export default PhoneNumberModal;
